import { observer } from 'mobx-react-lite';
import React from 'react';

import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';

import { FooterCD } from './FooterCD';
import { FooterDE } from './FooterDE';
import { LayoutCD } from './LayoutCD';
import { LayoutLocaleeV2 } from './LayoutLocaleeV2';

const getFooter = (companyName: CompanyName) => {
  switch (companyName) {
    case CompanyName.CityDrinks:
      if (company.newDesignSystemEnabled) {
        return FooterCD;
      }
      return LayoutCD;
    case CompanyName.DubaiExpress:
    case CompanyName.DubaiExpressCom:
      return FooterDE;
    default:
      return LayoutLocaleeV2;
  }
};

export default observer(
  React.forwardRef<
    HTMLDivElement,
    Omit<React.ComponentPropsWithRef<'footer'>, 'children'>
  >((props, ref) => {
    const Content = getFooter(company.name);

    return <Content {...props} ref={ref} />;
  }),
);
